import type { API } from 'api/config/types';
import { createGetTimeControl } from 'src/chessboard/api/time-control/model/get-time-control';
import { createGetTimeControlType } from 'src/chessboard/api/time-control/model/get-time-control-type';
import { createSetTimeControl } from 'chessboard/api/time-control/model/set-time-control';

/**
 * Create the Time Control API.
 */
export function createTimeControlAPI(context: API.Context) {
  return {
    get: createGetTimeControl(context),
    getType: createGetTimeControlType(context),
    set: createSetTimeControl(context),
  };
}
